export const CHOOSE_LANGUAGE_PAGETITLE = 'Choose Language';
export const DEFAULT_TITLE_SUFFIX = 'JORI Configurator';

export const MSG2: Record<string,Record<string,string>> = {
    en: {
        'offer_3D-button_glb': 'Download 3D files (GLB)',
        'compose_pagetitle': 'Compose',
        'currency_selector': 'Currency: {CURRENCY}',
        'counter_overflow': '{n} item(s) not shown',
        'logout_button': 'Log out'
    },
    nl: {
        'offer_3D-button_glb': 'Downloaden van 3D bestanden (GLB)',
        'compose_pagetitle': 'Stel samen',
        'currency_selector': 'Valuta: {CURRENCY}',
        'counter_overflow': '{n} artikel(en) niet afgebeeld',
        'logout_button': 'Uitloggen'
    },
    de: {
        'offer_3D-button_glb': 'Herunterladen von 3D-Dateien (GLB)',
        'compose_pagetitle': 'Stell zusammen',
        'currency_selector': 'Währung: ${CURRENCY}',
        'counter_overflow': '{n} nicht gezeigte(r) Gegenstand(e)',
        'logout_button': 'Sich abmelden'
    },
    fr: {
        'offer_3D-button_glb': 'Télécharger les fichiers 3D (GLB)',
        'compose_pagetitle': 'Composez',
        'currency_selector': 'Monnaie: ${CURRENCY}',
        'counter_overflow': '{n} article(s) non illustré(s)',
        'logout_button': 'Déconnexion'
    }
}